import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { Mail, MapPin, Facebook, Linkedin } from "lucide-react";

// Pinterest SVG icon component
const PinterestIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/>
  </svg>
);

export const Footer = () => {
  return (
    <footer className="bg-gradient-hero text-white pb-20 lg:pb-0">
      <div className="container mx-auto px-4">
        {/* Main Footer Content */}
        <div className="py-8">
          <div className="grid md:grid-cols-3 gap-8">
            {/* Newsletter + Over ons - left column */}
            <div className="space-y-6">
              <div className="space-y-3">
                <h3 className="font-semibold text-white text-sm">Blijf op de hoogte</h3>
                <p className="text-white/70 text-xs">
                  Ontvang tips en updates over auto theorie.
                </p>
                <div className="flex gap-2">
                  <Input 
                    placeholder="Je email" 
                    className="bg-white/10 border-white/20 text-white placeholder:text-white/50 h-8 text-xs"
                  />
                  <Button variant="accent" size="sm" className="h-8 px-3">
                    <Mail className="w-3 h-3" />
                  </Button>
                </div>
              </div>
              
              <div className="space-y-2">
                <h3 className="font-semibold text-white text-sm">Over ons</h3>
                <p className="text-white/70 text-xs leading-relaxed">
                  Wij zijn een directory website en presenteren alleen informatie over aanbieders. 
                  Wij maken zelf geen inhoud en zijn niet verantwoordelijk voor de diensten van de vermelde aanbieders.
                </p>
              </div>
            </div>

            {/* Categorieën */}
            <div className="space-y-3">
              <h3 className="font-semibold text-white text-sm">Categorieën</h3>
              <ul className="grid grid-cols-2 gap-x-4 gap-y-1.5">
                <li><a href="/rijscholen" className="text-white/70 hover:text-white transition-smooth text-xs">Rijscholen</a></li>
                <li><a href="/online-theorie" className="text-white/70 hover:text-white transition-smooth text-xs">Online Training</a></li>
                <li><a href="/theorie-boeken" className="text-white/70 hover:text-white transition-smooth text-xs">Theorie Boeken</a></li>
                <li><a href="/tweewielers" className="text-white/70 hover:text-white transition-smooth text-xs">Motor & Brommer</a></li>
                <li><a href="/code95" className="text-white/70 hover:text-white transition-smooth text-xs">Code 95</a></li>
                <li><a href="/taxi" className="text-white/70 hover:text-white transition-smooth text-xs">Taxi Opleiding</a></li>
                <li><a href="/cbr" className="text-white/70 hover:text-white transition-smooth text-xs">CBR</a></li>
                <li><a href="/videos" className="text-white/70 hover:text-white transition-smooth text-xs">Video</a></li>
                <li><a href="/reviews" className="text-white/70 hover:text-white transition-smooth text-xs">Reviews</a></li>
                <li><a href="/nieuws" className="text-white/70 hover:text-white transition-smooth text-xs">Nieuws</a></li>
                <li><a href="/verenigingen" className="text-white/70 hover:text-white transition-smooth text-xs">Verenigingen</a></li>
                <li><a href="/vacatures" className="text-white/70 hover:text-white transition-smooth text-xs">Vacatures</a></li>
                <li><a href="/partners" className="text-white/70 hover:text-white transition-smooth text-xs">Partners</a></li>
              </ul>
            </div>

            {/* Support & Login */}
            <div className="space-y-3">
              <h3 className="font-semibold text-white text-sm">Support & Login</h3>
              <ul className="grid grid-cols-2 gap-x-4 gap-y-1.5">
                <li><a href="/help" className="text-white/70 hover:text-white transition-smooth text-xs">Help Center</a></li>
                <li><a href="/leerling-dashboard" className="text-white/70 hover:text-white transition-smooth text-xs">🎓 Leerling</a></li>
                <li><a href="/contact" className="text-white/70 hover:text-white transition-smooth text-xs">Contact</a></li>
                <li><a href="/auth" className="text-white/70 hover:text-white transition-smooth text-xs">🚗 Rijschool</a></li>
                <li><a href="/privacy" className="text-white/70 hover:text-white transition-smooth text-xs">Privacy</a></li>
                <li><a href="/over-ons" className="text-white/70 hover:text-white transition-smooth text-xs">Over ons</a></li>
                <li><a href="/disclaimer" className="text-white/70 hover:text-white transition-smooth text-xs">Disclaimer</a></li>
                <li><a href="/code95-login" className="text-white/70 hover:text-white transition-smooth text-xs">🚚 Code95</a></li>
                <li><a href="/algemene-voorwaarden" className="text-white/70 hover:text-white transition-smooth text-xs">Voorwaarden</a></li>
                <li><a href="/taxi/dashboard" className="text-white/70 hover:text-white transition-smooth text-xs">🚕 Taxi</a></li>
                <li><a href="/vereniging-auth" className="text-white/70 hover:text-white transition-smooth text-xs">🏛️ Vereniging</a></li>
                <li><a href="/partner-auth" className="text-white/70 hover:text-white transition-smooth text-xs">🤝 Partner</a></li>
              </ul>
            </div>
          </div>
        </div>

        <Separator className="bg-white/20" />

        {/* Zusterwebsites */}
        <div className="py-4">
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <span className="text-white/50 text-xs">Onze websites:</span>
            <a href="https://theorieaanbieders.nl" className="text-white/70 hover:text-white transition-smooth text-xs">theorieaanbieders.nl</a>
            <a href="https://oplaadpuntenzoeken.nl" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-smooth text-xs">oplaadpuntenzoeken.nl</a>
            <a href="https://deurbelvergelijken.nl" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-smooth text-xs">deurbelvergelijken.nl</a>
            <a href="https://vakmantool.nl" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-smooth text-xs">vakmantool.nl</a>
          </div>
        </div>

        <Separator className="bg-white/20" />

        {/* Bottom Footer */}
        <div className="py-4">
          <div className="grid md:grid-cols-3 gap-6 items-center">
            <p className="text-white/70 text-xs">© 2025-2026 Theorie Aanbieders. Alle rechten voorbehouden.</p>
            <div className="flex items-center gap-4">
              <a href="https://www.facebook.com/profile.php?id=61584097516478" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-smooth">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="https://www.linkedin.com/company/theorieaanbieders" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-smooth">
                <Linkedin className="w-4 h-4" />
              </a>
              <a href="https://nl.pinterest.com/theorieaanbieders/" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-smooth">
                <PinterestIcon className="w-4 h-4" />
              </a>
            </div>
            <div className="flex items-center gap-1 text-white/70 text-xs md:justify-end">
              <MapPin className="w-3 h-3" />
              <span>Nederland</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};